import { createStyles, Theme } from '@nelnet/unifi-components-react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    container: {
      borderBottom: '1.5rem solid #FFFFFF',
      padding: `${spacing(4)}px ${spacing(2)}px 0`,
      [breakpoints.up('sm')]: {
        padding: `${spacing(6)}px`,
      },
    },
    twoColumn: {
      display: 'inline',
    },
    bold: {
      fontWeight: 500,
      padding: `0 ${spacing(4)}px`,
      [breakpoints.up('md')]: {
        padding: '0 125px',
      },
    },
    listItem: {
      borderTop: '3px solid rgba(0, 0, 0, 0.12)',
      padding: '2rem 0 1rem',
    },
  });

export default styles;
